import { atom } from 'jotai'

type TFormNewAddress = {
    shipToAddress: {
        address1: string
        address2: string
        city: string
        state: string
        zip: string
        country: string
    }
    prefecture: string
    district: string
    town: string
    houseNumber: string
    shipToName: {
        fullName: string
    }
}
export const formNewAddressState = atom<TFormNewAddress>({
    shipToAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
    },
    prefecture: '',
    district: '',
    town: '',
    houseNumber: '',
    shipToName: {
        fullName: ''
    }
})

export const editedPhoneState = atom<string>('')
export const editedEmailState = atom<string>('')
export const displayEmailState = atom<string>('')
export const editedPhoneFormatState = atom<string>('')
export const formAddressFiledState = atom<{
    fullName: string
    zip: string
    prefecture: string
    district: string
    townNumber: string
    houseNumber: string
}>({
    fullName: '',
    zip: '',
    prefecture: '',
    district: '',
    townNumber: '',
    houseNumber: ''
})
